import { ApiResponse, Employee } from "@/types";
import { api } from "./client";

export const employeeService = {
  getByRoles: async (roles: string[]) => {
    const response = await api.post<ApiResponse<Employee[]>>(
      "employees/by-roles",
      { roles }
    );
    return response.responseBody.data;
  },
  getAll: async () => {
    const response = await api.get<ApiResponse<Employee[]>>("employees");
    // Map the API response to include computed fields for UI compatibility
    return response.responseBody.data.map((emp) => ({
      ...emp,
      name: `${emp.firstName} ${emp.lastName}`,
      joiningDate: emp.joinedDate,
    }));
  },
  getById: async (id: string) => {
    return api.get<Employee>(`employees/${id}`);
  },
  create: async (data: Omit<Employee, "id">) => {
    return api.post<Employee>("employees", data);
  },
  update: async (id: string, data: Partial<Employee>) => {
    return api.put<Employee>(`employees/${id}`, data);
  },
  delete: async (id: string) => {
    return api.delete(`employees/${id}`);
  },
  deleteAll: async () => {
    return api.delete("employees");
  },
  upload: async (file: File) => {
    return api.upload("employees/upload", file);
  },
};
